import { formatDate, mString } from 'lib/helpers/utility';

export const getColDefs = () => {
  return [
    { headerName: 'Name', field: 'name' },
    {
      headerName: 'Created date',
      field: 'created_at',
      valueGetter: ({ data }) => {
        return formatDate(data?.created_at);
      }
    },
    {
      headerName: 'Pt.Charge',
      field: 'total_amount',
      valueGetter: ({ data }) => mString(data?.total_amount + data?.tax)
    },
    {
      headerName: 'Balance',
      field: 'invoice_balance',
      valueFormatter: ({ data }) => mString(data?.invoice_balance)
    }
  ];
};
